import { Action } from '@ngrx/store';
import { RefNo } from '../../model/ngrx/reference-number.model';
import * as LoggedinDetailActions from './../actions/loggedin-detail.action';

export type Actions = LoggedinDetailActions.Actions;

export function LoggedinDetailReducer(state: [] = [], action: LoggedinDetailActions.Actions) {
    switch (action.type) {
        case LoggedinDetailActions.ADD_LOGGED_IN_DETAIL:
            return [...state, action.payload];
        case LoggedinDetailActions.REMOVE_LOGGED_IN_DETAIL:
            return [];
        default:
            return state;
    }
}
